/** Build-time configuration. Everything brand- or site-specific lives here. */
const env = import.meta.env;

export const BRAND: string = env.VITE_BRAND || 'VIA DOMUM';
export const API_URL: string = (env.VITE_API_URL || 'http://localhost:8000').replace(/\/+$/, '');
export const SITE: string = env.VITE_SITE || 'repat-ua.localhost';
export const DEFAULT_LOCALE: string = env.VITE_DEFAULT_LOCALE || 'uk';

export const OTP_LENGTH = 6;
/** Seconds before "send the code again" becomes available. */
export const RESEND_COOLDOWN_S = 60;
/** After a 429 we ask people to wait this long before trying again. */
export const RATE_LIMIT_COOLDOWN_S = 300;
export const ACCEPTED_MIME = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/webp', 'application/pdf'];
export const ACCEPT_ATTR = 'image/*,application/pdf';
export const CHAT_POLL_MS = 5000;

/**
 * Контакти компанії беруться лише з GET /public/site (налаштування сайту в CRM).
 * Заглушок немає: якщо значення не задане — рядок просто не показуємо.
 */
export const COMPANY_FALLBACK = {
  legalName: '',
  address: '',
  phone: '',
  email: '',
  dpoEmail: '',
};
